// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"58e3d85c","703":"f1362ded","787":"c8afd02c"}[chunkId] + ".chunk.js";
};